import React, {useState} from 'react';
import {connect} from 'react-redux';
import SMCPage from '../../../components/core/pageComponents/SMCPage';
import {useBoolean, useResultsTableDimensions} from '../../../utils/hooks';
import SMCTable from '../../../components/core/SMCTable/SMCTable';
import {useTranslation} from 'react-i18next';
import SMCButton from '../../../components/Simple/SMCButton';
import {useServerResults} from './serverResultsHelper';
import {isAdminReadOnlySelector} from '../../../store/selectors/user.selectors';
import {ServerGroupGetListSchema} from '../../../api/DBSchema/Server';
import SMCLabel from '../../../components/Simple/SMCLabel';
import RowLayout from '../../../components/Layouts/RowLayout';
import ServerWizard from '../../Wizards/ServerWizard';
import {push} from 'connected-react-router';
import {SMCPaths, helpContextPageUrl} from '../../../conf/Routes';

function ServerResults({
    navigateTo,
    isAdminReadOnly
}) {
    const { t } = useTranslation();

    const [tableWidth,] = useResultsTableDimensions();
    const [currentNewServerGroupName, setCurrentNewServerGroupName] = useState(null);
    const [isNewObjectWindowOpen, openNewObjectWindow, closeNewObjectWindow] = useBoolean(false);
    
    const {
        serverGroups,
        isFetching,
        isPageLoaded,
        serverTableColumns,
        serverTableRowIdSelector,
        newObjectCallback,
        reloadButtonOnClick
    } = useServerResults();

    return (
        <SMCPage loading={!isPageLoaded} helpId={helpContextPageUrl.serverResults}>
            <div className="DrawResultsDiv">
                {
                    !serverGroups && (
                        <h1>{t('com.sofaware.db.SERVERSGROUP_NO_GROUPS')}</h1>
                    )
                }
                {
                    serverGroups && (
                        <>
                        <SMCLabel>{t('SMC_SERVERS_UPPER_TEXT')}</SMCLabel>
                        {
                            serverGroups.map(serverGroup => {
                                const serverGroupName    = serverGroup[ServerGroupGetListSchema.name];
                                const serverGroupServers = serverGroup[ServerGroupGetListSchema.servers];
                                return (
                                    <React.Fragment key={serverGroupName}>
                                        <SMCLabel bold fontSize="16px">{serverGroupName}</SMCLabel>
                                        <RowLayout style={{ padding: '6px 0' }}>
                                            <SMCButton
                                                disabled={isAdminReadOnly || isFetching}
                                                onClick={() => {
                                                    setCurrentNewServerGroupName(serverGroupName);
                                                    openNewObjectWindow();
                                                }}
                                            >
                                                {t('SMC_SERVERS_NEW_SRV')}
                                            </SMCButton>
                                            <SMCButton disabled={isFetching} onClick={() => navigateTo(SMCPaths.serverGroups+'?id='+serverGroupName)}>{t('SMC_SERVERS_EDIT_TIP')}</SMCButton>
                                        </RowLayout>
                                        <SMCTable
                                            columns={serverTableColumns}
                                            content={serverGroupServers}
                                            loading={isFetching}
                                            rowIdSelector={serverTableRowIdSelector}
                                            isRowSelectable={false}
                                            width={tableWidth}
                                            // hasCheckboxColumn={false}
                                        />
                                    </React.Fragment>
                                )
                            })
                        }
                        <SMCButton style={{ margin: '6px 0' }} disabled={isFetching} onClick={reloadButtonOnClick}>{t('SMC_SERVERS_REFRESH_SRV')}</SMCButton>
                        </>
                    )
                }
                {/* Floating windows */}
                <ServerWizard
                    isOpen={isNewObjectWindowOpen}
                    onRequestClose={closeNewObjectWindow}
                    onSuccess={newObjectCallback}
                    groupName={currentNewServerGroupName}
                />
            </div>
        </SMCPage>
    );
}

const mapStateToProps = state => ({
    isAdminReadOnly: isAdminReadOnlySelector(state)
});

const mapDispatchToProps = {
    navigateTo: push
}

export default connect(mapStateToProps, mapDispatchToProps)(ServerResults);